import React, { FC } from 'react';
import { HeadFC, graphql } from 'gatsby';
import SEO from '../../components/Head';
import LayoutRaw from '../../components/Layout';

import View from '../../views/Wallet';

interface ContextType {
  locale: string;
  name: string;
}

const WalletPage: FC = () => {
  return (
    <LayoutRaw>
      <View />
    </LayoutRaw>
  );
};

export const Head: HeadFC<Queries.HomeQueryQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query WalletQuery($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/home/**" }) {
      childJson {
        ...Meta
      }
    }
  }
`;

export default WalletPage;
